module.exports = __webpack_public_path__ + "528a8d2351f88520788db0d38b334698.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/chest.png
// module id = 2781
// module chunks = 0